import React from 'react';
import { Link } from 'react-router-dom';
import ReactJson from 'react-json-view'
import { inject, observer } from "mobx-react";
import BN from 'bignumber.js'
import swal from 'sweetalert';
import Select from 'react-select';

@inject("UiStore")
@observer
export class ThirdStep extends React.Component {
  constructor(props){
    super(props);
    this.tokenStore = props.UiStore.tokenStore;
    this.gasPriceStore = props.UiStore.gasPriceStore;
    console.log(this.gasPriceStore.gasPricesArray)
    this.onNext = this.onNext.bind(this)
    this.onPrev = this.onPrev.bind(this)
    this.state = {
      gasPrice: ''
    }
  }
  componentDidMount() {
    if(this.tokenStore.dublicates.length > 0){

      swal({
        title: `数据中存在重复的以太坊地址`,
        text: `${JSON.stringify(this.tokenStore.dublicates.slice(), null, '\n')}.\n AirDroper已经合并了这些地址的转账金额。`,
        icon: "warning",
      })
    }
  }
  onPrev(e){
    e.preventDefault()
    this.props.history.goBack()
  }
  onNext(e) {
    e.preventDefault();
    if (new BN(this.tokenStore.totalBalance).gt(new BN(this.tokenStore.defAccTokenBalance))){
      console.error('Your balance is more than total to send')
      swal({
        title: "代币余额不足",
        text: `没有足够的代币完成全部发送。\n待发送总量： ${this.tokenStore.totalBalance} ${this.tokenStore.tokenSymbol}`,
        icon: "error",
      })
      return
    }
    if( new BN(this.tokenStore.totalCostInEth).gt(new BN(this.tokenStore.ethBalance))){
      console.error('please fund you account in ')
      swal({
        title: "以太币余额不足",
        text: `没有足够的以太币完成全部发送。 待发送总量：${this.tokenStore.totalCostInEth} ETH`,
        icon: "error",
      })
      return
    }
    this.props.history.push('/4')
  }

  onGasPriceChange = (selected) => {
    if(selected){
      this.gasPriceStore.setSelectedGasPrice(selected.value)
    }
  }
  render() {
    return (
      <div className="container container_bg">
        <div className="content">
          <h1 className="title">欢迎使用 <strong>AirDroper</strong>批量发送工具。</h1>
          <p className="description">
            你可以使用 <b>AirDroper</b> 批量转账以太币或ERC20代币，
            一键完成大量地址的代币分发任务。
          </p>
          <form className="form">
            {/*<ReactJson displayDataTypes={false}
              style={{backgroundColor: 'none'}}
              indentWidth="2"
              iconStyle="square"
              name={false}
              theme="solarized"
              src={this.tokenStore.jsonAddresses.slice()} />*/}
              
              <div style={{padding: "0px 0px 25px 0px"}}>
                <p>交易确认速度(GAS价格)</p>
                <Select.Creatable
                  isLoading={this.gasPriceStore.loading}
                  value={this.gasPriceStore.selectedGasPrice}
                  onChange={this.onGasPriceChange}
                  loadingPlaceholder="Fetching gas Price data ..."
                  placeholder="Please select desired network speed"
                  options={this.gasPriceStore.gasPricesArray.slice()}
                />
              </div>
            <div className="send-info">
              <div className="send-info-side">
                <div className="send-info-i">
                  <p>待发送总量</p>
                  <p className="send-info-amount">{this.tokenStore.totalBalance} {this.tokenStore.tokenSymbol}</p>
                </div>
                <div className="send-info-i">
                  <p>代币余额</p>
                  <p className="send-info-amount">{this.tokenStore.defAccTokenBalance} {this.tokenStore.tokenSymbol}</p>
                </div>
                {/*<div className="send-info-i">
                  <p>每批次交易手续费</p>
                  <p className="send-info-amount">{this.tokenStore.currentFee} ETH</p>
                </div>*/}
                <div className="send-info-i">
                  <p>以太币余额</p>
                  <p className="send-info-amount">{this.tokenStore.ethBalance}</p>
                </div>
              </div>
              <div className="send-info-side">
                <div className="send-info-i">
                  <p>目标地址总数</p>
                  <p className="send-info-amount">{this.tokenStore.jsonAddresses.length}</p>
                </div>
                <div className="send-info-i">
                  <p>当前授权额度</p>
                  <p className="send-info-amount">{this.tokenStore.allowance} {this.tokenStore.tokenSymbol}</p>
                </div>
                {/*<div className="send-info-i">
                  <p>全部发送所需批次数</p>
                  <p className="send-info-amount">{this.tokenStore.totalNumberTx}</p>
                </div>
                <div className="send-info-i">
                  <p>全部发送预估总成本</p>
                  <p className="send-info-amount">
                  {this.tokenStore.totalCostInEth} ETH        
                  </p>
                </div>*/}
                <div className="send-info-i">
                  <p>GAS价格</p>
                  <p className="send-info-amount">
                  {this.gasPriceStore.selectedGasPrice} gwei
                  </p>
                </div>
              </div>
            </div>
            
            <Link onClick={this.onNext} className="button button_next" to='/4'>下一步</Link>
          </form>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/3.js